Vue.component('ppcarto-popup', {
  template: `<div>YEAH</div>`
});
